<!--赖传峰-->
<!--2021/12/15-->
<template>
  <ul class="nav">
    <li
      v-for="el in pageLinks"
      :key="el.link"
    >
      <a :href="el.link">
        <component
          :is="el.icon"
          color="var(--color-secondary-text)"
        />
        <span class="nav-item-name">{{ el.title }}</span>
      </a>
    </li>
  </ul>
</template>

<script
  lang="ts"
  setup
>
import {
  computed,
  useI18n,
} from '#imports'
import { RoutePathOfDrive } from '@/types/enum'
import FileSolidIcon from '~/components/icons/FileSolidIcon.vue'
import RecentSolidIcon from '~/components/icons/RecentSolidIcon.vue'
import TrashMenuSolidIcon from '~/components/icons/TrashMenuSolidIcon.vue'

const { t } = useI18n()

const pageLinks = computed(() => [
  {
    link: RoutePathOfDrive.ALL,
    title: t('all-files'),
    icon: FileSolidIcon,
  },
  {
    link: RoutePathOfDrive.RECENT,
    title: t('recent-files'),
    icon: RecentSolidIcon,
  },
  {
    link: RoutePathOfDrive.TRASH,
    title: t('trash'),
    icon: TrashMenuSolidIcon,
  },
])

</script>

<style
  lang="less"
  scoped
>
@import '@/assets/styles/util';

.nav {
  margin-top: 8px;

  a {
    display: flex;
    height: 44px;
    align-items: center;
    padding-left: 12px;
    text-decoration: none;
    border-radius: 4px;
    transition: all var(--transition-delay) var(--transition-animation);
    color: var(--color-secondary-text);

    &:hover, .hover {
      background: #ececec;
    }

    &.active {
      color: var(--color-primary);
      background: fade(#3f85ff, 10%);

      .nav-item-name {
        font-weight: 600;
      }
    }
  }
}

.nav-item-name {
  line-height: 18px;
  margin-left: 8px;
}

@media screen and (max-width: @mobile-break-width) {
  .nav {
    margin-bottom: 0;
  }

  a {
    font-size: 16px;
  }
}
</style>
